import React, { useState } from "react";
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import "../style/auto.css";
import a from '../Assets/Bofors.png'
import b from '../Assets/Kedarnath.png'
import c from '../Assets/UMP Image.png'
import d from '../Assets/Military base.png'



function Autoslider  (){
    const data=[ {
        "src": a,
        "alt": "Image 1 for carousel",
        "tex":"3D Artillery"
      },
      {
        "src": b,
        "alt": "Image 2 for carousel",
        "tex":"Kedarnath VR",
      },

      {
        "src": c,
        "alt": "Image 3 for carousel",
        "tex":"Ultimate military base pack"
      },

      {
        "src": d,
        "alt": "Image 4 for carousel",
        "tex":"3D Weapon"
      }
    ]

  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    setSlide(slide === data.length - 1 ? 0 : slide + 1);
  };

  const prevSlide = () => {
    setSlide(slide === 0 ? data.length - 1 : slide - 1);
  };

  return (
    <div className="carousel">
      <BsArrowLeftCircleFill onClick={prevSlide} className="arrow arrow-left" />
      {data.map((item, idx) => {
        return (
            <div className="imgs">
          <img
            src={item.src}
            alt={item.alt}
            key={idx}
            className={slide === idx ? "slide" : "slide slide-hidden"}
          />
          <div className='x11'><p>{item.tex}</p></div>
          </div>
        );
      })}
      <BsArrowRightCircleFill
        onClick={nextSlide}
        className="arrow arrow-right"
      />
      {/* <span className="indicators">
        {data.map((_, idx) => {
          return (
            <button
              key={idx}
              className={
                slide === idx ? "indicator" : "indicator indicator-inactive"
              }
              onClick={() => setSlide(idx)}
            ></button>
          );
        })}
      </span> */}
    </div>
  );
};

export default Autoslider;